import { render, staticRenderFns } from "./AdvertisersTableDetailsModalDetails.vue?vue&type=template&id=c5193f70&scoped=true"
import script from "./AdvertisersTableDetailsModalDetails.vue?vue&type=script&lang=js"
export * from "./AdvertisersTableDetailsModalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5193f70",
  null
  
)

export default component.exports